export default {
  /*** Filtrer tableau avec array unique ******/
    filterUniqueKeyStructure( array  ){
                        
        var unique = [];
        var distinct = [];
        for(var i = 0; i < array.length; i++ ){
          if(!unique[array[i].fk_structure.id]){
            distinct.push(array[i]);
            unique[array[i].fk_structure.id] = 1;
          }
        }
        return distinct;
    },
    filterUniqueKeyEuroclass( array  ){
                        
        var unique = [];
        var distinct = [];
        for(var i = 0; i < array.length; i++ ){
          if(!unique[array[i].fk_euroclass.id]){
            distinct.push(array[i]);
            unique[array[i].fk_euroclass.id] = 1;
          }
        }
        return distinct;
    },

    /**
     * 
     * @param {Si la clé existe dan sun array / Object} array 
     * @param {*} key 
     * @returns 
     */
    existKeyInArray( key , array ){
      if( key in array ){
        return true;
      }
      else{
        return false;
      }

  },

  

    /**
     * 
     * @param {Ajout d'une ligne au panier'} $this 
     */
    AjoutLignePrePanier($this, longueur){
     
    
      var indexTab = Object.keys($this.$store.state.storePrePanier.StoreShowPrePanierListe).length;
      var id_perso = indexTab + '-' + Math.floor(Math.random() * 100000) + 1


      //Check si dans liste des réference gérées
      if(this.IsRefGeree == true){
        this.obj = {
        
        };
      }
      else{
       
        //Création reference prk

         //Changement détat si probléme
        this.etat = true;
        //Si plus de 1000 métres
      
        if(longueur >= 1000){

          this.etat = false;
          this.etatLongueur = false;
          this.ref_prk = ""
          this.ref_encode = "test"

          this.prixPalier = "";

          
        }
        //Si moin de 1000 métres
        else{
          
          this.ref_prk = this.createPrkRef($this, longueur);
          this.ref_encode = $this.$CryptoJS.AES.encrypt(this.ref_prk , process.env.VUE_APP_SALT_ENCODE).toString();
          this.getPrixPalier($this, id_perso, longueur );
          this.etatLongueur = true;
        }


        this.obj = {
        pays: $this.$store.state.storeGlobal.StorePays,
        id:indexTab,
        // pk: null,
        sessionId: $this.$store.state.storeUser.sessionId,
        id_perso: id_perso,
        connecteur_a: $this.$store.state.storeCoA.coA.type.TypeCoA,
        connecteur_a_diametre: $this.$store.state.storeCoA.coA.diametre.typeDiametre,
        type_chaussette: $this.$store.state.storeChaussette.chaussette.chaussette.typeChaussette,
        nombre_fibre: $this.$store.state.storeCable.cable.nombre.nbFibre,
        euroclass: $this.$store.state.storeCable.cable.euroclass.nomEuroclass,
        type_fibre: $this.$store.state.storeCable.cable.type.TypeFibre,
        qte_stock_cable: $this.$store.state.storeCable.cable.reference.qteCableDispo,
        reference_cable: $this.$store.state.storeCable.cable.reference.referenceCable,
        longueur: longueur,
        connecteur_b: $this.$store.state.storeCoB.coB.type.TypeCoB,
        ref_prk: this.ref_prk , 
        pa_prk: this.ref_encode , 
        type_structure: $this.$store.state.storeCable.cable.structure.libelleStructure,
        ref_structure: $this.$store.state.storeCable.cable.structure.codeRefStructureFamille,
        etat: this.etat,
        etatLongueur: this.etatLongueur,
        refGerree: false,
        doc_paths: {
          "fiche-technique": process.env.VUE_APP_URL_API + "/pdf/" + (this.ref_prk.replace(" ", "_")) + "_" + id_perso + ".pdf",
        }

      };

      }


      
     
      $this.$store.commit('ADD_PRE_PANIER_LISTE', this.obj )
      //$store.commit('INCREMENT_PRE_PANIER_LISTE',  [ { id:1, nom:"test1 "},{ id:2, nom:"test2 "},{ id:3, nom:"test3 "}] )

      // //todo log the configuration by sending it to /api/createConfiguration
      // const configuration = {
      //   info : this.obj,
      //   user : $this.$store.state.storeUser.user,
      //   designationAffaire : "Configuration fibre PRE-T",
      // };
      // fetch($this.$store.state.storeGlobal.StoreApi + '/createConfiguration', {
      //   method: "POST",
      //   body: JSON.stringify(configuration),
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   // mode: 'no-cors',
      // }
      // ).then(response => {
      //   console.log(response)
      //   // return response.json()
      // });
    },



     /**
     * 
     * @param {Ajout d'une ligne ref gerree au panier'} $this 
     */
     AjoutLignePrePanierRefGerree($this, value){

      var indexTab = Object.keys($this.$store.state.storePrePanier.StoreShowPrePanierListe).length;
      var id_perso = indexTab + '-' + Math.floor(Math.random() * 100000) + 1

      this.ref_prk = value.reference;
      this.ref_encode = $this.$CryptoJS.AES.encrypt(this.ref_prk , process.env.VUE_APP_SALT_ENCODE).toString();
      this.getPrixRefGerree($this, id_perso, value.longueur , value );
      this.etatLongueur = true;

      this.obj = {
        id:indexTab,
        pays: $this.$store.state.storeGlobal.StorePays,
        // pk: null,
        id_perso: id_perso,
        sessionId: $this.$store.state.storeUser.sessionId,
        connecteur_a: $this.$store.state.storeCoA.coA.type.TypeCoA,
        connecteur_a_diametre: $this.$store.state.storeCoA.coA.diametre.typeDiametre,
        type_chaussette: $this.$store.state.storeChaussette.chaussette.chaussette.typeChaussette,
        nombre_fibre: $this.$store.state.storeCable.cable.nombre.nbFibre,
        euroclass: $this.$store.state.storeCable.cable.euroclass.nomEuroclass,
        type_fibre: $this.$store.state.storeCable.cable.type.TypeFibre,
        reference_cable: $this.$store.state.storeCable.cable.reference.referenceCable,
        longueur: value.longueur,
        qte_stock_cable: $this.$store.state.storeCable.cable.reference.qteCableDispo,
        connecteur_b: $this.$store.state.storeCoB.coB.type.TypeCoB,
        ref_prk: this.ref_prk , 
        pa_prk: this.ref_encode , 
        type_structure: $this.$store.state.storeCable.cable.structure.libelleStructure,
        ref_structure: $this.$store.state.storeCable.cable.structure.codeRefStructureFamille,
        etat: true,
        etatLongueur: this.etatLongueur,
        refGerree: true,
        pa_palier: value.reference ,
        ean : value.ean ,
        doc_paths: {
          "fiche-technique": process.env.VUE_APP_URL_API + "/pdf/" + (this.ref_prk.replace(" ", "_")) + "_" + id_perso + ".pdf",
        }

      };

      $this.$store.commit('ADD_PRE_PANIER_LISTE', this.obj )

 
    },



    /**
     * 
     * @param {Log user configuration} $this 
     * @returns 
     */
    logConfiguration($this, item){
  
      // log the configuration by sending it to /api/createConfiguration
      const configuration = {
        info : item,
        user : $this.$store.state.storeUser.user,
        designationAffaire : "Configuration fibre PRE-T",
      };
     
      fetch($this.$store.state.storeGlobal.StoreApi + '/createConfiguration', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
        },
        body: JSON.stringify(configuration),
      
      }
      ).then(response => {
        return response.json()
      }).then(json => {
        $this.globalFunction.MajLignePrePanierNoPa($this, item.id_perso , 'pk' , json.pk );
        // return response.json()
      });
    },
    /**
     * 
     * @param {Update a user configuration log} $this 
     * @returns 
     */
    updateLogConfiguration($this, id, values){
  
      const configuration = {
        id: id,
        user : $this.$store.state.storeUser.user,
        values: values
      };
     
      fetch($this.$store.state.storeGlobal.StoreApi + '/updateConfiguration', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
        },
        body: JSON.stringify(configuration),
        // mode: 'no-cors',
      }
      ).then(response => {
    
        return response.json()
      }).then(json => {
        return json
        // $this.globalFunction.MajLignePrePanierNoPa($this, item.id_perso , 'pk' , json.pk );
        // return response.json()
      });
    },

    /**
     * 
     * @param {Création ref PRK} $this 
     * @returns 
     */
    createPrkRef($this, longueur){


        //Nombre de fibre
        var nombreFibre = $this.$store.state.storeCable.cable.nombre.nbFibre

        //structure + dim ( preco structure ref)
        var familleStructure = $this.$store.state.storeCable.cable.structure.codeRefStructure

        //mode fibre
        var Type_fibre = $this.$store.state.storeCable.cable.type.TypeFibreCodeRef
      
        //Connecteur tirage
        var coA = $this.$store.state.storeCoA.coA.type.codeRefCoA
       
        //Connecteur non tirage
        var coB = $this.$store.state.storeCoB.coB.type.codeRefCoB
      
        //Euroclass  StoreCodeRefEuroclassFibre
        var euroclass = $this.$store.state.storeCable.cable.euroclass.codeRefEuroclass
        //Longueur
        var longueurStore =  longueur
        var longueurRef = ('00' + longueurStore).slice(-3)

        var refCommercial = 
        "PRK " +
        nombreFibre + 
        familleStructure +
        Type_fibre +
        coA +
        coB +
        euroclass +
        longueurRef

        return refCommercial;
    },
    IsRefGeree(){
      return false;
    },

    /**
     * 
     * @param {Suppression d'un ligne dans le pré panier'} $store 
     * @param {*} id_perso 
     */
    DeleteLignePrePanier($store, id_perso){
      //ajout fetch request pour modifier l'etat de la configuration pour la session
      fetch($store.state.storeGlobal.StoreApi + '/api/configuration/update', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $store.state.storeGlobal.StoreJwtToken
        },
        body: JSON.stringify({
          id: id_perso
        }),
        // mode: 'no-cors',
      }
      ).then(response => {
        return response.json()
      }).then(json => {
        return json
      });
      $store.commit('DELETE_PRE_PANIER_LISTE', id_perso )
      $store.commit('REMOVE_FICHE_TECHNIQUE_STATUS', id_perso)
    },

    /**
     * 
     * @param {Maj d'un ligne dans le pré panier'} $this 
     * @param {*} id_perso 
     * @param {*} libelle_tab 
     * @param {*} value 
     */
    MajLignePrePanier($this, id_perso , libelle_tab , value){
      var data = [];
      data.id_perso = id_perso;
      data.libelle_tab = libelle_tab;
      data.value = value;
   
      $this.$store.commit('MAJ_PRE_PANIER_LISTE', data)
    },
    MajLignePrePanierNoPa($this, id_perso , libelle_tab , value){
      var data = [];
      data.id_perso = id_perso;
      data.libelle_tab = libelle_tab;
      data.value = value;
   
      $this.$store.commit('MAJ_PRE_PANIER_LISTE_NO_PA', data)
    },


        /**
     * 
     * @param {*} $this 
     * @param {*} id_perso 
     */
        getPrixRefGerree($this , id_perso, longueur ,value ){
            
          fetch($this.$store.state.storeGlobal.StoreApi + '/api/price/webshop', {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
            },
            body: JSON.stringify({ 
              coa : $this.$store.state.storeCoA.coA.type.codeRefCoA ,
              cob : $this.$store.state.storeCoB.coB.type.codeRefCoB ,
              nbfibre : $this.$store.state.storeCable.cable.nombre.nbFibre ,
              refcable : $this.$store.state.storeCable.cable.reference.referenceCable,
              longueurcable : longueur,
              typefibre : $this.$store.state.storeCable.cable.type.TypeFibreCodeRef,
              typestructure : $this.$store.state.storeCable.cable.structure.codeRefStructure,
              pays : $this.$store.state.storeGlobal.StorePays
            })
          }
          ).then(response => {
        return response.json()
      
      }).then(data => {
   
       // Utilisation du prix lpfr de la ref gerree au lieu de la ref palier 
    var price_ref_geree_decrypt = $this.$CryptoJS.AES.decrypt(value.prix_ref_geree, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8) * 0.45
    var price_ref_geree_arround_decrypt = Math.round(price_ref_geree_decrypt * 100) / 100

    var price_ref_geree = $this.$CryptoJS.AES.encrypt( price_ref_geree_decrypt.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();
    var price_ref_geree_arround = $this.$CryptoJS.AES.encrypt( price_ref_geree_arround_decrypt.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();

        //TODO prix net cable ??
         /** prix webshop */
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'palier' , value.reference );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'libelle_palier' , data.libelle_palier );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , value.reference );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_net_palier' , price_ref_geree_arround );

          /** prix custmer ***/
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable_km' , data.prix_cable_km );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable' , data.prix_cable );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_connecteur' , data.prix_connecteur );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot' , price_ref_geree );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot_arround' , price_ref_geree_arround );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_co' , data.ref_co );
          const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === id_perso);
          $this.globalFunction.logConfiguration($this, item)
          $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)
    

      }).catch(function() {
        $this.globalFunction.MajLignePrePanier($this, id_perso , 'erreur_prix' , true );
        $this.globalFunction.MajLignePrePanier($this, id_perso , 'libelle_palier' , 'Erreur' );
        $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , false );
        $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_net_palier' , false );
        $this.globalFunction.MajLignePrePanier($this, id_perso , 'palier' , 'Erreur' );
        $this.globalFunction.MajLignePrePanierNoPa($this, id_perso , 'etat' , false );
        const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === id_perso);
        $this.globalFunction.logConfiguration($this, item)
        $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)
      });
      
        },


    /**
     * 
     * @param {*} $this 
     * @param {*} id_perso 
     */
    getPrixPalier($this , id_perso, longueur){
            
      fetch($this.$store.state.storeGlobal.StoreApi + '/api/price/webshop', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
        },
        body: JSON.stringify({ 
          coa : $this.$store.state.storeCoA.coA.type.codeRefCoA ,
          cob : $this.$store.state.storeCoB.coB.type.codeRefCoB ,
          nbfibre : $this.$store.state.storeCable.cable.nombre.nbFibre ,
          refcable : $this.$store.state.storeCable.cable.reference.referenceCable,
          longueurcable : longueur,
          typefibre : $this.$store.state.storeCable.cable.type.TypeFibreCodeRef,
          typestructure : $this.$store.state.storeCable.cable.structure.codeRefStructure,
          pays : $this.$store.state.storeGlobal.StorePays
        })
      }
      ).then(response => {
    return response.json()
  
  }).then(data => {

    /** Depassement du dernier prix palier */
    if( $this.$store.state.storeGlobal.StoreEnvWeb == "Webshop" 
    && data.palier == 'GGM PRET0790'
    ){
      throw new Error('Something went wrong');
    }
    else if( ($this.$store.state.storeGlobal.StoreEnvWeb == "CustomerCare GIGAMEDIA" 
    || $this.$store.state.storeGlobal.StoreEnvWeb == "Site Gigamedia" 
     ) && data.palier == 'GGM PRET0790'){
      var prixTotDecode = $this.$CryptoJS.AES.decrypt(data.prix_tot, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8)
      var prixTotDecodeArround = Math.round((parseFloat(prixTotDecode ) + Number.EPSILON) * 100) / 100;

      data.prix_net_palier = $this.$CryptoJS.AES.encrypt( prixTotDecodeArround.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();

    }


    /** prix webshop */
     /** prix webshop */ 
     if($this.$store.state.storeGlobal.StorePays == 'NL'){
      $this.globalFunction.MajLignePrePanier($this, id_perso , 'custom_ref_nl' , data.custom_ref_nl );
    }
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'palier' , data.palier );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'libelle_palier' , data.libelle_palier );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , data.ref_palier );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_net_palier' , data.prix_net_palier );

    /** prix custmer ***/
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable_km' , data.prix_cable_km );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable' , data.prix_cable );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_connecteur' , data.prix_connecteur );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot' , data.prix_tot );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot_arround' , data.prix_tot_arround );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_co' , data.ref_co );

    //var encryptedText = this.$CryptoJS.AES.encrypt("Hi There!", "Secret Passphrase").toString()
    
    //var dataDecrypt = this.$CryptoJS.AES.decrypt(encryptedText, "Secret Passphrase").toString(this.$CryptoJS.enc.Utf8)
    /*
    var phpencode = data.test_encode;
    console.log(phpencode);

    var decodephp =  this.$CryptoJS.AES.decrypt(phpencode, "@1Vol7YgpOfBaHUw!8GFZFkwJ4^Q").toString(this.$CryptoJS.enc.Utf8)
    console.log(decodephp);
    */
    const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === id_perso);
    $this.globalFunction.logConfiguration($this, item)
    $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)
  }).catch((error) => {
    console.log(error)
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'erreur_prix' , true );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'libelle_palier' , 'Erreur' );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , false );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_net_palier' , false );
    $this.globalFunction.MajLignePrePanier($this, id_perso , 'palier' , 'Erreur' );
    $this.globalFunction.MajLignePrePanierNoPa($this, id_perso , 'etat' , false );
    const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === id_perso);
    $this.globalFunction.logConfiguration($this, item)
    $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)
  });
    },

    getCodeRefStructure($store ) {
    
        //Appel de l'api + transofrmation Json'
        fetch($store.state.storeGlobal.StoreApi + '/api/preco_structure_refs?' +
        "fk_type_structure=" + $store.state.storeCable.cable.structure.pkStructureId + 
        "&droite=" +  $store.state.storeCoB.coB.diametre.pkDiametre   +
        "&gauche=" + $store.state.storeCoA.coA.diametre.pkDiametre  ,{
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $store.state.storeGlobal.StoreJwtToken
        },
        }
     ).then(response => {
      return response.json()
    
     }).then(data => {
 
    
      this.objStructure = {  
        'cable' : {
          'structure' : {
            codeRefStructure: data[0].code_ref,
      }
      }};
      $store.commit('PUT_CABLE_STRUCTURE', this.objStructure )

    
     })
    },

}
